import { useLingui } from '@lingui/react/macro';
import { Chip } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import useAppStore from '../../store/rootStore';
import { DELEGATED_CHIP_LABEL, OWNER_CHIP_LABEL } from './constants';

/** "Delegated" / "Owner" chips for the wallet trigger and menu header. */
export function DelegationChips({ sx }: { sx?: SxProps<Theme> }) {
  const { t } = useLingui();
  const isDelegated = useAppStore((state) => state.isDelegated);
  const isDelegatedOwner = useAppStore((state) => state.isDelegatedOwner);

  return (
    <>
      {isDelegated ? <Chip label={t(DELEGATED_CHIP_LABEL)} size="small" color="warning" sx={sx} /> : null}
      {isDelegatedOwner ? <Chip label={t(OWNER_CHIP_LABEL)} size="small" color="primary" sx={sx} /> : null}
    </>
  );
}
